import styled from 'styled-components'

export const Root = styled.div`
    display: none;
    @media(max-width: 800px) {
        display: block;
    }
`